
import { Options, Vue } from "vue-class-component";

@Options({
  name: "StoreBtn",
})
export default class StoreBtn extends Vue {
  private onClickAction(): void {
    this.$router.push({ path: "/cart" });
  }
}
